import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = { click: { 'tab': 'changeTab', } };
        this.tabs = [...this.$( 'tab' )];
        this.tabContents = [...this.$( 'tab-content' )];
    }
    changeTab( e ){
        let target = e.currentTarget;
        if( e.currentTarget.classList.contains( 'active' ) ) return;
        target.parentNode.querySelector( '.tab.active' ).classList.remove( 'active' );
        target.classList.add( 'active' );
        this.tabContents.forEach( tabContent => tabContent.classList.remove( 'active' ) );
        this.tabContents[ this.tabs.indexOf( target )  ].classList.add( 'active' );
    }

    init() {}
    destroy(){}
}
